
<div class="page" v-if="performer">
    <div class="container">

        <Sidebar></Sidebar>
        
        <div class="profile" :class="{'mobile': userStore.mobile }">
            
            <slider v-if="showSlider" :userId="account.id" :fullscreen="true" :key="getCurrentSliderMedia.length" :medias="getCurrentSliderMedia" :performer="performer" :current="displayCurrentSlide" @close="displaySlider = false"></slider>

            <div class="profile__header" v-if="!userStore.mobile">
                <div class="profile__header-bg"><span v-bind:style="{ 'background-image': 'url(' + performerSnapShot(performer).url + ')' }"></span></div>
                <div class="profile__header-avatar" :style="{ 'background-image': `url(${getAvatar(performer)})`}"></div>
                
                <div class="profile__header-controls">
                    <div class="profile__header-payment" v-if="hasIVR">
                        <span class="profile__header-payment-text" v-if="!isLoggedIn() && showCTA != 'email'">
                            <div v-if="userStore.isPaymentMethod() === 'phone' && !hasAttemptedWithoutIvrCode">{{ $t('tabs.warningpaybyphone') }}</div>
                            <div v-if="hasAttemptedWithoutIvrCode">{{ $t('tabs.warningnoivrcode') }}</div>
                        </span>
                        <span class="profile__header-payment-choice" v-if="userStore.isPaymentMethod() === 'phone'" @click="isLoggedIn() ? userStore.changePaymentMethod('credits') : toggleModal('login')">{{ $t('profile.session.paywithcredits') }}</span>
                        <span class="profile__header-payment-choice" v-if="userStore.isPaymentMethod() === 'credits'" @click="userStore.changePaymentMethod('phone')">{{ $t('profile.session.paywithphone') }}</span>
                    </div>
        
                    <div class="profile__header-actions">
        
                        <div class="profile__header-phone" v-if="hasIVR && userStore.isPaymentMethod() === 'phone' && showCTA != 'email'">
                            <div class="numbers numbers--big numbers--bold">
                                <span class="numbers__nr" v-for="i of numbers">
                                    <i :class="`numbers__nr-flag  fflag fflag-${i.country.toUpperCase()} ff-md`"></i> 
                                    {{ i.number }}<b>{{ $filters.currency(i.tariff) }}  {{ $t('header.numbers.currency') }}</b>
                                </span>
                                <p v-t="'tabs.webcamwithphonedesc'"></p>
                            </div>
                            <div class="row">
                                <div class="row__col2">
                                    <div class="form__group form__group-small" :class="{'form__group-disabled': 'code' in form.errors}">
                                        <input type="tel" min="0" max="99999" maxlength="5" v-model="form.ivrCode" @keypress="numbersOnly" :placeholder="$t('tabs.accesscode')" required>
                                    </div>
                                </div>
                                <div class="row__col2">
                                    <div class="form__group form__group-small" :class="{'form__group-disabled': 'name' in form.errors}">
                                        <input type="text" maxlength="30" v-model="form.name" :placeholder="$t('tabs.username')" required>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="profile__header-actions-main" v-if="showCTA === 'cam'">
                            <div class="profile__header-actions-main" :class="{'col1': userStore.isPaymentMethod() === 'phone' || !haveVIP, 'col2': userStore.isPaymentMethod() != 'phone' && haveVIP }">
                                <button class="btn btn-green btn-full" :class="tabEnabled('cam', performer) && !isLoading ? '' : 'disabled'" @click="initiateService('chat')">
                                    <i class="se se-cam"></i> {{ $t(`tabs.service-cam`) }}
                                </button>
                            </div>
                            <div class="profile__header-actions-main col2" v-if="userStore.isPaymentMethod() === 'credits' && haveVIP">
                                <button class="btn btn-vip btn-full"  :class="tabEnabled('vipcam', performer) && !isLoading ? '' : 'disabled'" @click="initiateService('vipchat')">cam</button>
                            </div>
                        </div>

                        <button v-if="showCTA === 'peek'" class="btn btn-green btn-full" :class="isLoading ? 'disabled' : '' " @click="initiateService('peek')">
                            <i class="se se-peek"></i> {{ $t('tabs.service-peek') }}
                        </button>
                        <button v-if="showCTA === 'email'" class="btn btn-green btn-full" :class="tabEnabled('email', performer) ? '' : 'disabled'" @click="sendMessage()">
                            <i class="se se-email"></i> {{ $t('tabs.service-email') }}
                        </button>

                        <div class="profile__header-actions-cols">
                            <span v-if="hasIVR">
                                <button class="btn btn-small btn-grey btn-full teaser" :class="tabEnabled('videocall', performer) && !isLoading ? '' : 'disabled'" @click="initiateService('videocall')">
                                    <i class="se se-videocall"></i> {{ $t('tabs.service-videocall') }}
                                </button>
                            </span>
                            <span v-if="userStore.isPaymentMethod() === 'credits'">
                                <button class="btn btn-small btn-grey btn-full teaser" :class="tabEnabled('voyeur', performer) && !isLoading ? '' : 'disabled'" @click="initiateService('teaser')">
                                    <i class="se se-voyeur"></i> {{ $t('tabs.service-voyeur') }}
                                </button>
                            </span>
                            <span v-if="userStore.isPaymentMethod() !== 'credits' && hasIVR">
                                <button class="btn btn-small btn-grey btn-full" :class="tabEnabled('phone', performer) ? '' : 'disabled'" @click="scrollBottom(); selectTab('phone')">
                                    <i class="se se-phone"></i> {{ $t('tabs.service-phone') }}
                                </button>
                            </span>
                            <span v-if="showCTA === 'email'">
                                <button class="btn btn-small btn-grey btn-full teaser"  :class="tabEnabled('cam', performer) && !isLoading ? '' : 'disabled'" @click="initiateService('chat')">
                                    <i class="se se-cam"></i> {{ $t(`tabs.service-cam`) }}
                                </button>
                            </span>
                            <span v-else>
                                <button class="btn btn-small btn-full btn-grey" :class="tabEnabled('email', performer) ? '' : 'disabled'" @click="sendMessage()">
                                    <i class="se se-email"></i> {{ $t('tabs.service-email') }}
                                </button>
                            </span>
                        </div>
                        <a @click="scrollTabs();" v-if="hasIVR">{{ $t('profile.moreservices') }}</a>
                    </div>
                </div>
            </div>

            <div class="profile__info">
                <div class="performer">
                    <div class="performer__header">
                        <div class="performer__header-performer">
                            <div class="performer__header-performer--status"><span :class="'status ' + performerStatusColor(performer)"></span></div> 
                            <div class="performer__header-performer--nickname">
                                {{ performer.nickname }}
                            </div>
                            <div class="performer__header-performer--controls">
                                <span :class="{ active: isFavorite(performer.id) }" @click.stop.prevent="toggleFavorites" class="favorites"></span>
                                <span :class="{ active: isSubscribed(performer.id) }" @click.stop.prevent="toggleNotifications" class="notification"></span>
                            </div>
                        </div>
                    </div>
                    <div class="performer__id">
                        {{ $t('profile.id') }}: <i>{{ performer.advertNumber }}</i>
                    </div>
                    <div class="performer__content">
                        <div class="performer__content-description">
                            {{ $filters.truncate(performer.description, !displayFullDescription ? 390 : 999, '...') }}
                            <div class="performer__content-links">
                                <a v-if="performer.description.length > 390" v-on:click="displayFullDescription = !displayFullDescription">
                                    {{ displayFullDescription ? $t('profile.readless') : $t('profile.readmore') }}
                                </a>
                                <a v-if="!userStore.mobile && performer.hasOwnProperty('availability')" @click="scrollBottom();">
                                    {{ $t('profile.agenda.view') }}
                                </a>
                            </div>
                        </div>
                        <ul class="performer__content-char">
                            <li v-if="performer.gender && isDusk">
                                <span>{{ $t('profile.gender') }}</span>
                                <span>{{ $t('profile.genders.' + performer.gender) }}</span>
                            </li>
                            <li v-if="isDusk && performerOrientations.length > 0">
                                <span>{{ $t('profile.orientation') }}</span>
                                <span>{{ performerOrientations.map(o => $t('profile.orientations.' + o)).join(', ') }}</span>
                            </li>
                            <li v-if="performer.age">
                                <span>{{ $t('profile.age') }}</span>
                                <span>{{ performer.age }}</span>
                            </li>
                            <li v-if="performer.height">
                                <span>{{ $t('profile.height') }}</span>
                                <span>{{ performer.height }}</span>
                            </li>
                            <li v-if="performer.weight">
                                <span>{{ $t('profile.weight') }}</span>
                                <span>{{ performer.weight }}</span>
                            </li>
                            <li v-if="performer.cupSize">
                                <span>{{ $t('profile.cupsize') }}</span>
                                <span>{{ transformCupSize(performer.cupSize) }}</span>
                            </li>
                            <li>
                                <span>{{ $t('profile.lastonline') }}</span>
                                <span>{{ format(fromUnixTime(performer.statusUpdated), 'dd-MM-yyyy') }}</span>
                            </li>
                            <li v-if="performer.location">
                                <span>{{ $t('profile.location') }}</span>
                                <span>{{ extractLocation(performer.location) }}</span>
                            </li>
                            <li class="toy" v-if="performer.services.toy.status != 'off'">
                                {{ $t('profile.toyavailable') }}
                                <i class="fa-solid fa-vibo small"></i>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            
            <div class="profile__media" v-if="!userStore.mobile">
                <mGrid :performer="performer" :medias="getCurrentMedia" @toggleSlider="toggleSlider" :key="getCurrentMedia.length"></mGrid>
            </div>

            <div class="profile__tabs tabs" v-if="!userStore.mobile" id="tabs">
                <div class="tabs__titles">
                    <div class="tabs__titles-title" v-for="service in TabsServices" :class="{'active': activeService === service && tabsEnabled, 'disabled': !tabEnabled(service, performer) }" @click="selectTab(service)">
                        <i class="se" :class="'se-'+service"></i>
                        <span>{{ $t(`tabs.service-${service === 'cam' ? camLabel : service}`) }}</span>
                    </div>
                    <div class="tabs__titles-title tabs__titles-title-vip" v-if="haveVIP" :class="{'active': activeService === 'vipcam' && tabsEnabled, 'disabled': !tabEnabled('vipcam', performer) }" @click="selectTab('vipcam')">
                        <span>{{ $t(`tabs.cam`) }}</span>
                    </div>
                </div>

                <cam v-if="(activeService === 'cam' || activeService === 'peek') && tabsEnabled " :performer="performer" :form="form" @initiate="initiate" :isLoading="isLoading"></cam>
                <videocall v-if="activeService === 'videocall' && tabsEnabled" :performer="performer" :form="form" @initiate="initiate" :isLoading="isLoading"></videocall>
                <voyeur v-if="activeService === 'voyeur' && tabsEnabled" :performer="performer" :form="form" @initiate="initiate" :isLoading="isLoading"></voyeur>
                <phone v-if="activeService === 'phone' && tabsEnabled && hasIVR" :performer="performer"></phone>
                <email v-if="activeService === 'email' && tabsEnabled" :performer="performer"></email>
                <vipcam v-if="activeService === 'vipcam' && tabsEnabled" :performer="performer" :form="form" @initiate="initiate" :isLoading="isLoading"></vipcam>
                <none v-if="activeService === 'none' && tabsEnabled"></none>
            </div>
            
            <div class="profile__agenda" id="agenda" v-if="!userStore.mobile && performer.hasOwnProperty('availability')">
                <agenda :performer="performer"></agenda>
            </div>

            <div class="profile__mActions" v-if="userStore.mobile">
                <div class="profile__mActions-phone" v-if="userStore.isPaymentMethod() === 'phone'">
                    <div class="numbers numbers--big numbers--bold">
                        <span class="numbers__nr" v-for="i of numbers">
                            <i :class="`numbers__nr-flag  fflag fflag-${i.country.toUpperCase()} ff-md`"></i> 
                            {{ i.number }}<b>{{ $filters.currency(i.tariff) }}  {{ $t('header.numbers.currency') }}</b>
                        </span>
                        <p v-t="'tabs.webcamwithphonedesc'"></p>
                    </div>
                    <div class="row">
                        <div class="row__col2">
                            <div class="form__group form__group-small" :class="{'form__group-disabled': 'code' in form.errors}">
                                <input type="tel" min="0" max="99999" maxlength="5" v-model="form.ivrCode" @keydown="numbersOnly" :placeholder="$t('tabs.accesscode')" required>
                            </div>
                        </div>
                        <div class="row__col2">
                            <div class="form__group form__group-small" :class="{'form__group-disabled': 'name' in form.errors}">
                                <input type="text" maxlength="30" v-model="form.name" :placeholder="$t('tabs.username')" required>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="profile__mActions-triggers" :class="{'norounded': userStore.isPaymentMethod() === 'phone'}">
                    <div class="profile__mActions-col">
                        <button v-if="camLabel === 'cam'" class="cam" :class="tabEnabled('cam', performer) && !isLoading ? '' : 'disabled'" @click="initiateService('chat')">
                            <i class="se se-cam"></i>
                        </button>
                        <button v-else class="peek" :class=" isLoading ? 'disabled' : ''"  @click="initiateService('peek')">
                            <i class="se se-peek"></i>
                        </button>
                    </div>
                    <div class="profile__mActions-col">
                        <button class="teaser" :class="tabEnabled('voyeur', performer) && !isLoading  ? '' : 'disabled'" @click="initiateService('teaser')">
                            <i class="se se-voyeur"></i>
                        </button>
                    </div>
                    <div class="profile__mActions-col" v-if="hasIVR">
                        <button class="phone" :class="tabEnabled('phone', performer) ? '' : 'disabled'" @click="startCall()">
                            <i class="se se-phone"></i>
                        </button>
                    </div>
                    <div class="profile__mActions-col">
                        <button class="email" :class="tabEnabled('email', performer) ? '' : 'disabled'" @click="isLoggedIn() ? router.push({ name: 'inbox', params: { view: 'compose', advertNumber: performer.advertNumber } }) : toggleModal('login')">
                            <i class="se se-email"></i>
                        </button>
                    </div>
                    
                    <span v-if="userStore.isPaymentMethod() === 'phone' && hasIVR" @click="isLoggedIn() ? userStore.changePaymentMethod('credits') : toggleModal('login')">{{ $t('profile.session.paywithcredits') }}</span>
                    <span v-if="userStore.isPaymentMethod() === 'credits' && hasIVR" @click="userStore.changePaymentMethod('phone')">{{ $t('profile.session.paywithphone') }}</span>
                </div>
            </div>
        </div>
    </div>
</div>
